import React, { useState } from 'react';
import AppIcon from '../ui/AppIcon';
import { FaEnvelope, FaPhone, FaMapMarkerAlt, FaPaperPlane } from 'react-icons/fa';

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    // Simulate form submission
    setTimeout(() => {
      setLoading(false);
      setSubmitted(true);
      setFormData({ name: '', email: '', subject: '', message: '' });
    }, 2000);
  };

  if (submitted) {
    return (
      <div className="container">
        <div className="contact-success">
          <AppIcon size={80} />
          <h1>Message Sent!</h1>
          <p>Thank you for reaching out. We'll get back to you within 24 hours.</p>
          <button 
            className="btn btn-primary"
            onClick={() => setSubmitted(false)}
          >
            Send Another Message
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="container">
      <div className="contact-page">
        <div className="contact-header">
          <AppIcon size={60} />
          <h1>Contact Us</h1>
          <p>We're here to help you on your mindfulness journey</p>
        </div>

        <div className="contact-content">
          <div className="contact-info">
            <h2>Get in Touch</h2>
            <p>
              Have questions about our platform, need technical support, or want to share feedback? 
              We'd love to hear from you.
            </p>

            <div className="contact-methods">
              <div className="contact-method">
                <FaEnvelope className="contact-icon" />
                <div>
                  <h3>Email Support</h3>
                  <p>support@nurturinginnerlove.com</p>
                  <small>We typically respond within 24 hours</small>
                </div>
              </div>

              <div className="contact-method">
                <FaPhone className="contact-icon" />
                <div>
                  <h3>Phone Support</h3>
                  <p>+1 (555) 123-4567</p>
                  <small>Mon-Fri, 9AM-5PM EST</small>
                </div>
              </div>

              <div className="contact-method">
                <FaMapMarkerAlt className="contact-icon" />
                <div>
                  <h3>Business Address</h3>
                  <p>123 Mindfulness Way<br />San Francisco, CA 94102</p>
                  <small>By appointment only</small>
                </div>
              </div>
            </div>

            <div className="response-times">
              <h3>Response Times</h3>
              <div className="response-grid">
                <div className="response-item">
                  <strong>General Inquiries:</strong> 24-48 hours
                </div>
                <div className="response-item">
                  <strong>Technical Support:</strong> 4-8 hours
                </div>
                <div className="response-item">
                  <strong>Billing Issues:</strong> 2-4 hours
                </div>
                <div className="response-item">
                  <strong>Emergency Issues:</strong> Within 1 hour
                </div>
              </div>
            </div>
          </div>

          <div className="contact-form-section">
            <h2>Send us a Message</h2>
            <form onSubmit={handleSubmit} className="contact-form">
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="name" className="form-label">Full Name</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    className="form-input"
                    placeholder="Your full name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="email" className="form-label">Email Address</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    className="form-input"
                    placeholder="your.email@example.com"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="subject" className="form-label">Subject</label>
                <select
                  id="subject"
                  name="subject"
                  className="form-input"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select a subject</option>
                  <option value="general">General Inquiry</option>
                  <option value="technical">Technical Support</option>
                  <option value="billing">Billing Question</option>
                  <option value="content">Content Feedback</option>
                  <option value="partnership">Partnership Opportunity</option>
                  <option value="other">Other</option>
                </select>
              </div>

              <div className="form-group">
                <label htmlFor="message" className="form-label">Message</label>
                <textarea
                  id="message"
                  name="message"
                  className="form-input"
                  rows="6"
                  placeholder="Please describe your question or concern in detail..."
                  value={formData.message}
                  onChange={handleChange}
                  required
                ></textarea>
              </div>

              <button 
                type="submit" 
                className="btn btn-primary w-full"
                disabled={loading}
              >
                {loading ? (
                  <>
                    <div className="spinner"></div>
                    Sending...
                  </>
                ) : (
                  <>
                    <FaPaperPlane />
                    Send Message
                  </>
                )}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;
